import { render, staticRenderFns } from "./TabNotifications.vue?vue&type=template&id=128d1a64"
import script from "./TabNotifications.vue?vue&type=script&lang=ts"
export * from "./TabNotifications.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports